import { random } from 'lodash'

export const rand = (randObj, token, exp, loginKey) => {

  if (!randObj) {
    const randomNumKey = random(0, 9999999999)
    return { randomNumKey, loginKey, exp, t: token, value: `${randomNumKey}:${token}:${loginKey}:${exp}:` }
  }

  let randKey = ''
  const itemKeys = ['_rnkey', 'Visp.token', '_utype', 'Visp.token-expiry']

  itemKeys.forEach(item => {
    randKey += `${localStorage.getItem(item)}:`
  })

  return randKey
}